export enum RouteEnum{
  EDIT = "edit",
  LIST = "list"
}
